// These are the error codes any of the three confirm/resend endpoint families
// return when the underlying application/batch is already done — the second
// click of a link now sitting in two inboxes is the normal case, not a
// failure, so it renders as success.
const ALREADY_CONFIRMED_CODES = new Set(["ALREADY_CONFIRMED", "RESUME_REUPLOAD_ALREADY_CONFIRMED", "BULK_INTAKE_ALREADY_CONFIRMED"]);

// A superseded or expired link still has live staged work behind it — a
// resend can recover it. Everything else (invalid token, job closed, window
// closed, resend limit reached) is a dead end a resend cannot fix.
const RESENDABLE_ERROR_CODES = new Set(["CONFIRMATION_LINK_SUPERSEDED", "CONFIRMATION_TOKEN_EXPIRED", "BULK_INTAKE_CONFIRMATION_TOKEN_EXPIRED"]);

/**
 * Classifies a confirm/resend error response into what the landing page
 * should render: success (already-confirmed family), an error with a
 * resend affordance, an error with a resend affordance gated by a cooldown,
 * or a plain dead-end error. Structural on `error_code` only — never on the
 * server's `message` text, which the product owner may reword.
 */
export const classifyConfirmationOutcome = (errorCode) => {
  if (errorCode && ALREADY_CONFIRMED_CODES.has(errorCode)) {
    return { status: "success" };
  }

  if (errorCode === "CONFIRMATION_RESEND_TOO_SOON") {
    return { status: "error", canResend: "cooldown" };
  }

  if (errorCode && RESENDABLE_ERROR_CODES.has(errorCode)) {
    return { status: "error", canResend: true };
  }

  return { status: "error", canResend: false };
};
